// extracted by mini-css-extract-plugin
module.exports = {"text_vendor":"PlanDetail_text_vendor__2wkqE"};